import { Calendar, getCalendarEntry, updateCalendarEntry } from 'owa-calendar-cache';
import { isSelectedCalendar, setCalendarColorScheme } from 'owa-calendar-surface-calendars-store';

import type CalendarColor from 'owa-service/lib/contract/CalendarColor';
import type { CalendarEntry } from 'owa-graph-schema';
import { refreshAssignedColorScheme } from 'owa-calendar-color-resolver';

export function updateCalendarColorScheme(
    calendar: Calendar,
    entry: CalendarEntry,
    newColor: CalendarColor
): void {
    // update calendar cache entry color and the assigned calendar color cache
    updateCalendarEntry(entry.calendarId.id, { CalendarColor: newColor });

    if (isSelectedCalendar(calendar)) {
        // if calendar is selected, resolve the new color and update items on the surface
        const colors = refreshAssignedColorScheme({
            ...calendar.id,
            id: entry.calendarId.id,
        });

        // update colorScheme for the calendar in store
        setCalendarColorScheme(calendar, colors);
    }
}

export function updateCalendarColor(calendar: Calendar, newColor: string): void {
    const entry = getCalendarEntry(calendar);
    const updateEntry = {
        HexColorString: newColor,
        CalendarColor: entry.CalendarColor,
    };
    if (
        entry.CalendarColor == -1 ||
        entry.CalendarColor == null ||
        entry.CalendarColor == undefined
    ) {
        // mark the calendar color as "not auto"
        updateEntry.CalendarColor = 0;
    }
    if (!newColor) {
        // if new color is undefined, we're setting auto
        updateEntry.CalendarColor = -1;
    }
    updateCalendarEntry(entry.calendarId.id, updateEntry);
    const colors = refreshAssignedColorScheme({ ...calendar.id, id: entry.calendarId.id });

    // update colorScheme for the calendar in store
    setCalendarColorScheme(calendar, colors);
}
